{
  "name": "events-portal",
  "version": "2.0.0",
  "scripts": {
    "ng": "ng",
    "start": "nx serve events-portal",
    "build": "nx build events-portal",
    "test": "nx test events-portal",
    "lint": "nx lint events-portal",
    "build-prod": "nx build events-portal --configuration=production",
    "build-dev": "nx build events-portal --configuration=development",
    "unit-test": "nx test events-portal --watch=false",
    "storybook": "storybook dev -p 6006",
    "build-storybook": "storybook build"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.0",
    "@angular/cdk": "^19.2.0",
    "@angular/common": "^19.2.0",
    "@angular/compiler": "^19.2.0",
    "@angular/core": "^19.2.0",
    "@angular/forms": "^19.2.0",
    "@angular/google-maps": "^19.2.0",
    "@angular/material": "^19.2.0",
    "@angular/material-moment-adapter": "^19.2.0",
    "@angular/platform-browser": "^19.2.0",
    "@angular/platform-browser-dynamic": "^19.2.0",
    "@angular/router": "^19.2.0",
    "@azure/storage-blob": "^12.24.0",
    "@fortawesome/angular-fontawesome": "^1.0.0",
    "@fortawesome/fontawesome-svg-core": "^6.7.0",
    "@fortawesome/free-solid-svg-icons": "^6.7.0",
    "@microsoft/applicationinsights-web": "^3.3.0",
    "bootstrap": "^5.3.3",
    "guid-typescript": "^1.0.9",
    "hammerjs": "^2.0.8",
    "jsonpath-plus": "^10.4.0",
    "moment": "^2.30.1",
    "moment-timezone": "^0.5.45",
    "ng-recaptcha": "^13.2.1",
    "ngx-bootstrap": "^19.0.0",
    "ngx-toastr": "^19.0.0",
    "null-prune": "^1.0.3",
    "rxjs": "^7.8.1",
    "ts-md5": "^1.2.11",
    "tslib": "^2.7.0",
    "uuid": "^10.0.0",
    "xml2js": "^0.6.2",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.0",
    "@angular/cli": "^19.2.0",
    "@angular/compiler-cli": "^19.2.0",
    "@angular/language-service": "^19.2.0",
    "@nx/angular": "^20.0.0",
    "@nx/eslint": "^20.0.0",
    "@nx/eslint-plugin": "^20.0.0",
    "@nx/workspace": "^20.0.0",
    "@storybook/addon-essentials": "^8.6.18",
    "@storybook/addon-interactions": "^8.6.18",
    "@storybook/angular": "^8.6.18",
    "@storybook/blocks": "^8.6.14",
    "@types/jasmine": "~5.1.4",
    "@types/node": "^22.10.0",
    "@types/uuid": "^10.0.0",
    "angular-eslint": "^19.0.0",
    "eslint": "^9.16.0",
    "jasmine-core": "~5.4.0",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "karma-junit-reporter": "^2.0.1",
    "nx": "^20.0.0",
    "storybook": "^8.6.18",
    "ts-node": "~10.9.2",
    "typescript": "~5.7.2",
    "typescript-eslint": "^8.18.0"
  },
  "overrides": {
    "axios": "^1.12.0",
    "xml2js": "^0.6.2",
    "jsonpath": "^1.1.1",
    "semver": "^7.6.3",
    "braces": "^3.0.3",
    "tough-cookie": "^4.1.4",
    "word-wrap": "^1.2.5",
    "postcss": "^8.4.47",
    "loader-utils": "^3.3.1",
    "socket.io-parser": "^4.2.4",
    "engine.io": "^6.6.2",
    "tar@6": "^7.5.22",
    "minimatch@9.0.0 - 9.0.6": "^9.0.9",
    "nx": {
      "minimatch": "^9.0.9"
    },
    "picomatch@4.0.0 - 4.0.3": "^4.0.7",
    "serialize-javascript": "^7.1.2",
    "esbuild@0.27.3 - 0.28.0": "^0.28.2",
    "piscina": "^4.9.4",
    "vite": "^6.4.3",
    "http-proxy-middleware@3.0.0 - 3.0.6": "^3.0.7",
    "webpack-dev-middleware": "^7.4.6",
    "@babel/core": "^7.29.7",
    "adm-zip@<=0.6.0": "^0.6.1",
    "koa@2": "^2.16.4",
    "ws@8.0.0 - 8.20.1": "^8.21.3",
    "webpack@5.49.0 - 5.104.0": "^5.105.0",
    "pacote": "^22.0.0"
  }
}
